// Boston's own trading contact, used as the default service/seller agent for
// equipment that is "Managed By Us". There is exactly one such contact in the
// deployed database — update here if the contact record is ever replaced.
export const BOSTON_SOUTH_WEST_CONTACT = {
  contact_id: "ct_e33be550e85047388bafa90fe39302a6",
  name: "Boston SW",
};
